import { TrainVariantDoorForCheckList } from "../models/TrainVariantDoorForCheckList";
import { DoorForChecklist } from "../models/VariantAndDoorsForChecklist.model";

export function downloadFile(data, contentDisposition) {
    const fileName = parseFilename(contentDisposition);
    const blob = new Blob([data], { type: "application/octet-stream" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

export function getCheckedState(doors: TrainVariantDoorForCheckList[] | DoorForChecklist[], upperDoor: boolean) {
    return hasSelectedDoors(doors, upperDoor) && areAllDoorsSelected(doors, upperDoor);
}

export function getIntermediateState(doors: TrainVariantDoorForCheckList[] | DoorForChecklist[], upperDoor: boolean) {
    return hasSelectedDoors(doors, upperDoor) && !areAllDoorsSelected(doors, upperDoor);
}

function hasSelectedDoors(doors: any[], upperDoor: boolean) {
    let relevantDoors = doors.filter(x => x.isUpperDoor === upperDoor);
    let selectedDoors = relevantDoors.filter(x => x.isSelected === true);

    return selectedDoors.length > 0;
}

function areAllDoorsSelected(doors: any[], upperDoor: boolean) {
    let relevantDoors = doors.filter(x => x.isUpperDoor === upperDoor);
    let selectedDoors = relevantDoors.filter(x => x.isSelected === true);

    return relevantDoors.length === selectedDoors.length;
}

export function indexOfField(source: any[], propName: string, comapreValue): number {
    for (let index = 0; index < source.length; index++) {
        const element = source[index];
        if (element[propName] === comapreValue) {
            return index;
        }
    }
    return -1;
}

function parseFilename(contentDisposition): string {
    let fileName = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
    return fileName;
}